    <mat-toolbar class="toolbar-example">
        <mat-card-title>Room Details of {{panelName}}</mat-card-title>
        <span class="fill-remaining-space"></span>
        <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
    </mat-toolbar>


    <div class="panel-details-header-cards">
        <mat-card class="interviewer-header-card">
            <p>Interviewer's Name</p>
        </mat-card>
        <mat-card class="room-details-header-card">
            <p>Room Details</p>
        </mat-card>
    </div>    
    <div class="panel-details-content-cards">
        <mat-card class="interviewer-content-card">
            <table mat-table [dataSource]="panelMemberListData" class="mat-elevation-z8">
                <ng-container matColumnDef="position">
                    <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
                </ng-container>
                <ng-container matColumnDef="fullName">
                    <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} </td>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
            </table>
        </mat-card>

        <mat-card class="room-details-content-card" style="display: flex;">
        <table style="line-height: 1.5; font-size: 15px;">
            <tr>
                <td class="table-data-height">Process Name</td>
            </tr>
            <tr class="table-data-height">
                <td>Room Identification</td>
            </tr>
            <tr class="table-data-height">
                <td>Timing</td>
            </tr>
            <br />
            <tr class="table-data-height" *ngIf="meetingLink !== null">
                <td>Meeting Link</td>
            </tr>
        </table>
        <table style="line-height: 1.5; font-size: 15px;">
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 10px;">{{processName}}</span></td>
            </tr>
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 10px;">{{roomNo}}</span></td>
            </tr>
            <tr class="table-data-height">
                <td><b>:</b> <span style="margin-left: 10px;">{{processStartDate}}</span> <br /><span style="margin-left: 12px;">To {{processEndDate}}</span></td>
            </tr>
            <tr class="table-data-height" *ngIf="meetingLink !== null">
                <td>
                    <b>:</b>
                    <span>
                        <input value={{meetingLink}} class="meeting-link-input-text" />
                    </span>
                    &nbsp;
                    <mat-icon matTooltip="Copy" (click)="copyToClipboard(meetingLink)" svgIcon="copy-to-clipboard" style="width: 18px; height: 24px;" class="meeting-link-copy-icon"></mat-icon>
                    &nbsp;
                    <mat-icon matTooltip="Open in New Tab" (click)="openInNewTab(meetingLink)" svgIcon="open-in-new-tab" style="width: 18px; height: 24px;" class="meeting-link-open-new-tab-icon"></mat-icon>
                </td>
            </tr>
        </table>
    </mat-card>
    </div>
   
        <!-- <div class="panel-details-cards">
            <div class="grid-align mat-elevation-z4">
                <mat-card class="small-box-header">
                    <p>Interviewer's Name</p>
                </mat-card>
                <mat-card class="left-small-box-content">
                    <table mat-table [dataSource]="panelMemberListData" class="mat-elevation-z8">
                        <ng-container matColumnDef="position">
                            <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
                        </ng-container>
                        <ng-container matColumnDef="fullName">
                            <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} </td>
                        </ng-container>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                    </table>
                </mat-card>
            </div>
        
            <div class="grid-align mat-elevation-z4">
                <mat-card class="small-box-header">
                    <p>Room Details</p>
                </mat-card>
                <mat-card class="right-small-box-content">
                    <table>
                        <tr>
                            <td>Process Name:</td>
                            <td>{{processName}}</td>
                        </tr>
                        <tr>
                            <td>Room Identification:</td>
                            <td>{{roomNo}}</td>
                        </tr>
                        <tr>
                            <td>Timing:</td>
                            <td>{{processStartDate}} -To - {{processEndDate}}</td>
                        </tr>
                    </table>
                </mat-card>
            </div>
        </div> -->
    
    <div class="candidate-table">
        <table mat-table [dataSource]="candidateListData" class="mat-elevation-z8" matSort>
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Position </th>
                <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
            </ng-container>

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

           
            <ng-container matColumnDef="candidateName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Name </th>
                <td mat-cell *matCellDef="let element"> {{element.candidateName}} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <ng-container matColumnDef="contactNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact No. </th>
                <td mat-cell *matCellDef="let element"> {{element.contactNo}} </td>
            </ng-container>

            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                <td mat-cell *matCellDef="let element"> {{element.address}} </td>
            </ng-container>

            <ng-container matColumnDef="totalMarks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Marks </th>
                <td mat-cell *matCellDef="let element">{{element.totalMarks}}</td>
            </ng-container>

            <ng-container matColumnDef="score">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Secured Score </th>
                <td mat-cell *matCellDef="let element">{{element.score}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns2;" class="example-element-row"></tr>
        </table>
    </div>

<button class="btn-color-example btn-align" mat-raised-button (click)="notification()">
    Send notification
</button>


<!-- <div class="main-container">
    <div class="search-div">
        <mat-toolbar>
            <span class="fill-remaining-space"></span>
            <mat-card-title>Panel Details of {{panelName}}</mat-card-title>
            <span class="fill-remaining-space"></span>
        </mat-toolbar>
    </div>
    <mat-grid-list cols="2" rowHeight="150px" gutterSize="2px">
        <mat-grid-tile>
            <div class="example-small-box mat-elevation-z4">
                <mat-card-title>Panel Member's Name</mat-card-title>
                <mat-card-content class="pMember-table ">
                    <table mat-table [dataSource]="panelMemberListData" class="mat-elevation-z8">
                        ------ Position Column ------
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef> Sl No. </th>
                            <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
                        </ng-container>
                        ------- Name Column -----
                        <ng-container matColumnDef="fullName">
                            <th mat-header-cell *matHeaderCellDef> Panel Member Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.panelMemberName}} </td>
                        </ng-container>
                        ------- <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr> -------
                        <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                    </table>
                </mat-card-content>
            </div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="example-small-box mat-elevation-z4">
                <mat-card-title>Panel Details</mat-card-title>
                <mat-card-content>
                    <table>
                        <tr>
                            <td>Process Name:</td>
                            <td>{{processName}}</td>
                        </tr>
                        <tr>
                            <td>Room Identification:</td>
                            <td>{{roomNo}}</td>
                        </tr>
                        <tr>
                            <td>Timing:</td>
                            <td>{{processStartDate}} -To - {{processEndDate}}</td>
                        </tr>
                    </table>
                </mat-card-content>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
    <br>
    <button mat-raised-button (click)="notification()">
        <mat-icon>textsms</mat-icon>Send notification
    </button>
    <div class="candidate-table">
        <table mat-table [dataSource]="candidateListData" class="mat-elevation-z8" matSort>
            -------- Position Column --------
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Position </th>
                <td mat-cell *matCellDef="let element;let i = index;"> {{i+1}} </td>
            </ng-container>

            ------------ Appearance Column -------
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            -------- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -------

            ------------- Name Column ------------
            <ng-container matColumnDef="candidateName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Name </th>
                <td mat-cell *matCellDef="let element"> {{element.candidateName}} </td>
            </ng-container>

            -------------- Email-Id Column ------------------
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            -------- Contact No. Column ----------------
            <ng-container matColumnDef="contactNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact No. </th>
                <td mat-cell *matCellDef="let element"> {{element.contactNo}} </td>
            </ng-container>

            ------------- City Column ---------
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                <td mat-cell *matCellDef="let element"> {{element.address}} </td>
            </ng-container>

            ------------- Total Score  Column -----------------
            <ng-container matColumnDef="totalMarks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Marks </th>
                <td mat-cell *matCellDef="let element">{{element.totalMarks}}</td>
            </ng-container>

            ------------ Secured Score  Column --------------
            <ng-container matColumnDef="score">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Secured Score </th>
                <td mat-cell *matCellDef="let element">{{element.score}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns2;" class="example-element-row"></tr>
        </table>
    </div>
</div> -->